export default class BrowserBack {
  constructor(lenis) {
    this.lenis = lenis;
    this.init();
  }

  init() {
    function isSafari() {
      const ua = navigator.userAgent;
      return /^((?!chrome|android).)*safari/i.test(ua);
    }

    if (isSafari()) {
      window.addEventListener('pageshow', () => {
        // 再描画を促す
        requestAnimationFrame(() => {
          this.lenis?.stop();
          document.body.style.display = 'none';
          requestAnimationFrame(() => {
            document.body.style.display = '';
            this.lenis?.start();

            window.dispatchEvent(new Event('loadingComplete'));
          });
        });
      });
    }
  }
}
